// Entry point for the build script in your package.json — loaded by
// app/views/layouts/application.html.erb and app/views/layouts/authentication.html.erb
// (public marketing/content pages + passwordless auth flow). The dashboard
// layout loads app/javascript/dashboard.js instead (see ticket #2127: bundle
// split so high-traffic public/SEO pages don't ship dashboard-only JS).
import "@hotwired/turbo-rails"
import "./controllers"

// Chartkick/Chart.js removed from here (audit SEO 2026-07-23): unused on every
// marketing/dashboard page. Dashboard odds charts render via a custom SVG +
// chart_tooltip_controller, not Chartkick. The only real Chartkick consumer is
// /admin (backtest calibration, fixture replay/charts), which already ships it
// separately via app/javascript/admin.js.

import { bootstrapServiceWorker } from "./lib/service_worker_bootstrap"
bootstrapServiceWorker()
